/**
 * Dependencies
 */

import React from 'react';
import { styled } from '@material-ui/styles';
import { Button } from '@material-ui/core';
import axioswithAuth from "../helpers/axioswithAuth";
import mixpanel from "../helpers/mixpanel";

/**
 * Define style
 */

const DeactivateButton = styled(Button)({
    color: "#FFF",
    backgroundColor: "#E55557",
    boxShadow:
        "0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)",
    padding: "6px 16px",
    textDecoration: "none",
    lineHeight: "1.75",
    fontWeight: 500,
    borderRadius: "4px",
    width: "200px",
    "&:hover": {
        backgroundColor: "black"
    },
    "&:active": {
        boxShadow:
            "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)"
    }
});

/**
 * Define component
 */

function DeactivateAccountButton(props) {
  function handleDeactivation() {
    let yes = window.confirm('Are you sure?')

    if (yes) {
      axioswithAuth().put('/users/deactivate')
      if (process.env.NODE_ENV === 'production') {
        mixpanel.track('Deactivated account', { distinct_id: localStorage.getItem('id') })
      }
      localStorage.clear()
      window.location = '/'

    }
  }

  return (
    <DeactivateButton variant="contained" onClick={handleDeactivation} data-testid="button-deactivate-account">
      Deactivate Account
    </DeactivateButton>
  )
}

/**
 * Export component
 */

export default DeactivateAccountButton;
